
import { useCallback, useEffect, useState } from "react";
import { ArticleImageGallery } from "../articleImageGalleryComponenta/articleImageGalleryComponenta";
import { ArticleImagesFullScreenGalleryImageCounter } from "./articleImagesFullScreenGalleryImageCounter";
import ArticleImagesFullScreenGalleryMain from "./articleImagesFullScreenGalleryMain";


interface ArticleImagesFullScreenGalleryFrontProps {
    images: ArticleImageGallery[]
    index: number
    isLtr: boolean
    isVisible: boolean
    articleId: string
    close: (currentImageIndex: number) => void
    open?: () => void
}

export const ArticleImagesFullScreenGalleryFront = ({ images, index, isLtr, close, isVisible }: ArticleImagesFullScreenGalleryFrontProps) => {
    const numOfImages = images.length;
    const [currentImageIndex, setCurrentImageIndex] = useState<number>(index)

    const swipeRight = (): void => {
        const nextImageIndex = currentImageIndex === images.length - 1 ? 0 : currentImageIndex + 1
        setCurrentImageIndex(nextImageIndex)
    }

    const swipeLeft = (): void => {
        const nextImageIndex = currentImageIndex === 0 ? images.length - 1 : currentImageIndex - 1
        setCurrentImageIndex(nextImageIndex)
    }

    const handleKeyPress = useCallback((e: KeyboardEvent): void => {
        const target = e.target as HTMLElement;
        const isInputElement = target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable;
    
        if (isInputElement) {
            return;
        }
    
        e.preventDefault();
        switch (e.key) {
            case 'Escape':
                close(currentImageIndex);
                break;
            case 'ArrowLeft':
                swipeLeft();
                break;
            case 'ArrowRight':
                swipeRight();
                break;
        }
    }, [currentImageIndex, close, swipeLeft, swipeRight]);

    useEffect(() => {
        document.addEventListener("keydown", handleKeyPress as EventListener)
        return () => {
            document.removeEventListener("keydown", handleKeyPress as EventListener)
        }
    }, [handleKeyPress]);

    useEffect(() => {
        setCurrentImageIndex(index)
    }, [index]);

    if (isVisible) {
        return(<div key={"ArticleImagesFullScreenGallery"} role="dialog"
            aria-label="images gallery"
            id="images_gallery" className="SiteArticleImagesGallery"
            onClick={() => close(currentImageIndex)} tabIndex={0}>
            <div className="GalleryWrapper" onClick={e => e.stopPropagation()}>
                <ArticleImagesFullScreenGalleryMain images={images} isLtr={isLtr} currentImageIndex={currentImageIndex} close={close} />
                <ArticleImagesFullScreenGalleryImageCounter numOfImages={numOfImages} currentImageIndex={currentImageIndex} swipeLeft={swipeLeft} swipeRight={swipeRight} />
            </div>
        </div>)
    }else{
        return null;
    }

}
